interface TableCellTextProps {
  text: string
}
export default function TableCellText({text}: TableCellTextProps) {
  return <p className='table_cell_text'>{text}</p>
}
